import { httpClient } from '@/config/httpClient';

type DebitNoteFlagProps = {
  batchDebitNotesToFlag: {
    id: string;
    comment: string;
  }[];
};

export async function postDebitNoteFlag(data: DebitNoteFlagProps) {
  return httpClient.post('/batch-debit-note/flag', data);
}
